import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Refresh as RefreshIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { getFheTickets } from '../../data/TicketFhe/actions';

class TicketFhe extends PureComponent {
    static propTypes = {
        initialized: PropTypes.bool.isRequired,
        tickets: PropTypes.object.isRequired,
        homes: PropTypes.object.isRequired,
        getFheTickets: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized,
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshTickets();
    }

    refreshTickets = () => {
        const { getFheTickets } = this.props;
        this.setState({ loading: true });
        return getFheTickets()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `fheticket/${rowData.id}` });
    };

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`generic.ticketing.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshTickets,
                },
            ],
        };
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('fheTicketDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`),
            });
        }
        return actions;
    });

    renderData = memoizeOne(tickets => {
        const { homes } = this.props;
        let result = [];

        tickets.map((ticket, ticketId) => {
            const home = homes.get(String(ticket.get('homeId')));

            result.push({
                id: parseInt(ticketId),
                ref: ticket.get('ref'),
                label: ticket.get('label'),
                description: ticket.get('description'),
                createdAt: ticket.get('createdAt'),
                state: Translator.translate(`generic.ticketing.state.${ticket.get('state')}`),
                creator: ticket.get('creator'),
                homeLabel: home.get('label'),
                homeId: ticket.get('homeId'),
            });
        });
        return result;
    });

    navigateToHomeDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `home/detail/${rowData.homeId}` });
    };

    renderColumns = memoizeOne(profile => {
        const { history } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.home'),
                name: 'homeLabel',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('homeDetails')) && {
                    onClick: this.navigateToHomeDetail,
                    tooltip: Translator.translate(`general.showHome`),
                },
            },
            {
                title: Translator.translate('general.table.column.ref'),
                name: 'ref',
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('fheTicketDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`),
                },
            },
            {
                title: Translator.translate('general.table.column.description'),
                name: 'description',
            },
            {
                title: Translator.translate('general.table.column.createdAt'),
                name: 'createdAt',
            },
            {
                title: Translator.translate('general.table.column.stateSimple'),
                name: 'state',
            },
            {
                title: Translator.translate('general.table.column.creator'),
                name: 'creator',
            },
        ];
    });

    render() {
        const { loading } = this.state;
        const { profile, tickets } = this.props;
        return (
            <FHETable
                idTable="ticketingList"
                columns={this.renderColumns(profile)}
                data={this.renderData(tickets)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`generic.ticketing.table.title`)}
                emptyDataSourceMessage={Translator.translate(`generic.ticketing.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    return {
        profile: state.data.user,
        tickets: state.environments[history.environment].data.TicketFhe.get('list'),
        initialized: state.environments[history.environment].data.TicketFhe.get('initialized'),
        homes: state.environments[history.environment].data.Homes.get('list'),
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/TicketFhe/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { getFheTickets }), dispatch),
        )(TicketFhe),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/TicketFhe/index.js